export default "__VITE_ASSET__DT2$L2od__"